import { Box, Button, Card, Flex, Spinner, Text } from "@engaging-tech/components"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"

import useGetSurveyResultEmail from "../hooks/useGetSurveyResultEmail"
import EmailResent from "./emailResent"
import PublicResults from "./publicResults"
import ResendEmail from "./resendEmail"

const SuccessDialog = ({ isPrivate, title, savantaId, emailIndividualResult, surveyId, code }) => {
  const { t } = useTranslation(["organisation_survey"])
  const [emailResent, setEmailResent] = useState(false)

  const { data, getData, isLoading } = useGetSurveyResultEmail(surveyId, code, emailIndividualResult, false)

  if (isLoading) return <Spinner justifyContent="center" color="light.0" />

  if (emailIndividualResult && emailResent && data?.getSurveyResultEmail?.statusCode === 200)
    return <EmailResent t={t} getData={getData} setEmailResent={setEmailResent} />

  if (savantaId)
    return (
      <Card mt={[5, 5, 6]} mb={[6, 5]} elevation={8} p={4} bg="light.0" alignItems="center">
        <Text fontSize={[3, 4]} textAlign="center" fontWeight="500" display="block" mb={2}>
          Thank you for completing the survey. Click the button bellow to collect your reward
        </Text>
        <Button variant="primary.0" mb={3}>
          <a rel="noreferrer" target="_blank" href={`https://sample.savanta.com/V2/c/${savantaId}`}>
            Collect reward
          </a>
        </Button>
      </Card>
    )

  return (
    <Card data-testid="survey-success-dialog" mt={[5, 5, 6]} mb={[6, 5]} elevation={8} bg="light.0" alignItems="center">
      <Box bg="dark.7" py={[2, 3]} px={3} width={1 / 1} mb={5}>
        <Text fontSize={[3, 6]} textAlign="center" fontWeight="500" display="block">
          {title}
        </Text>
      </Box>
      <Flex flexDirection="column" alignItems="center" px={3} pb={3}>
        <Text color="dark.2" fontWeight="500" mb={3} textAlign="center">
          {t("thankyou.text1", "")}
        </Text>
        {!emailIndividualResult && (
          <Text fontWeight="500" fontSize={3} mb={5} textAlign="center">
            {t("thankyou.text2", "")}
          </Text>
        )}
        {emailIndividualResult && (
          <Text fontWeight="500" fontSize={3} mb={5} textAlign="center">
            {t("thankyou.text3", "")}
          </Text>
        )}
        {!isPrivate && !emailIndividualResult && <PublicResults t={t} />}
        {emailIndividualResult && <ResendEmail t={t} sendEmail={getData} setEmailResent={setEmailResent} />}
      </Flex>
    </Card>
  )
}

export default SuccessDialog
